export const NOTIFICATION_COUNT_UPDATE_THROTTLE_TIME = 1000;
